export default "__VITE_ASSET__b2648a8e__"